let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

$('.popup-youtube').magnificPopup({
  disableOn: 700,
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false
});

$('.home_test-wrapper').slick({
  infinite: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.media_list').slick({
  infinite: true,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
else
{jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});

if($(window).width() <= '989'){
  $('.service_block ul').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });
  $('.home_logo_block ul').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });
}

// jQuery(function () {
//         jQuery.magnificPopup.open({items: {src: '#popup-modal'},type: 'inline'}, 0);

//         jQuery(document).on('click', '.popup-modal-dismiss', function (e) {
//           e.preventDefault();
//           jQuery.magnificPopup.close();
//         });

//       });


//equalheight

$(function ($) {
$(window).on('load',function() {
equalheight('h3.card__heading.h5');
equalheight('h3.card__heading.top-title-package');
  
});

$(window).on('resize',function() {
equalheight('h3.card__heading.h5');
equalheight('h3.card__heading.top-title-package');  
});
});

$('.tab-a').click(function(){  
 $(".step_block").removeClass('tab-active');
 $(".step_block[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
 $(".tab-a").removeClass('active-a');
 $(this).parent().find(".tab-a").addClass('active-a');
});

$(function () {
	$('.btn.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true,
        mainClass: 'mfp-main_pops'
	});
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
});




